// This enum defines the possible statuses for a speed test, including none, completed, in progress for upload or download, and canceled.
// It is used to track the current state of the speed test process in the application.
export enum SpeedTestStatus {
	none = 'none',
	completed = 'completed',
	inProgressUpload = 'inProgressUpload',
	inProgressDownload = 'inProgressDownload',
	canceled = 'canceled',
}
